import type { MouseEvent } from 'react';
import React from 'react';
import type { Theme } from '@material-ui/core';
import { ListItem, ListItemText } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { Kommunikasjon, Illustration } from '@klp/design/Illustrations';
import { Block } from '@klp/design';
import { useKlpStyles } from '@klp/design/Theme/useKlpStyles';
import { Typography } from '@klp/design/Typography';
import { useDispatch } from 'react-redux';
import { leverandorActions } from '../../store/leverandorSlice';
import type { Aktivitet } from '@klp/formgenerator/interfaces';

export type MenuPopperSendKommentarProps = {
    roller: Array<string>;
    prosessInstansId: string | undefined;
    defaultRolle?: string;
    activity?: Aktivitet;
};

const styles = (theme: Theme) => ({
    iconContainer: {
        display: 'flex',
        alignItems: 'center',
        paddingRight: theme.spacing(2),
    },
});

export const MenuPopperSendKommentar = ({
    roller,
    prosessInstansId,
    defaultRolle,
    activity,
}: MenuPopperSendKommentarProps) => {
    const classes = useKlpStyles({}, styles);
    const { t } = useTranslation();
    const dispatch = useDispatch();

    const handleClick = (event: MouseEvent<HTMLDivElement>) => {
        event.stopPropagation();
        if (!prosessInstansId) return;
        dispatch(
            leverandorActions.setActiveModal({
                type: 'sendKommentar',
                prosessInstansId,
                roller,
                defaultRolle,
                activity,
            }),
        );
    };

    if (!roller.length) return null;

    return (
        <ListItem dense={true} button={true} onClick={handleClick}>
            <Block className={classes.iconContainer}>
                <Illustration pictogram={Kommunikasjon.EPOST} />
            </Block>
            <ListItemText>
                <Typography>
                    {t('leverandor.table.actionMenuItems.sendKommentar')}
                </Typography>
            </ListItemText>
        </ListItem>
    );
};
